import { InjectionToken } from '@angular/core';
import { ContentInterface, ContextInterface } from '@campus/dal';

export const OPEN_STATIC_CONTENT_SERVICE_TOKEN = new InjectionToken<OpenStaticContentServiceInterface>(
  'OpenStaticContentService'
);

/**
 * @param stream Should the content be streamed instead of downloaded? (used for video content)
 * @param showPreview Should the content open in a preview dialog on the page, instead of a new window?
 * @param fullscreen Should the preview dialog open fullscreen? Defaults to false.
 * @param useIFrame Should the content open in an iframe on the page, instead of a new window?
 * @param context The context of the content
 * @param disableMathjax Disable mathjax rendering
 * @param eduContentMetadataId Use a specific version
 * @param canPrint Can the current opened eduContent be printed
 */
export interface OpenStaticContentOptions {
  stream?: boolean;
  showPreview?: boolean;
  fullscreen?: boolean;
  useIFrame?: boolean;
  context?: ContextInterface;
  disableMathjax?: boolean;
  eduContentMetadataId?: number;
  canPrint?: boolean;
}

export interface OpenStaticContentServiceInterface {
  open(content: ContentInterface, options?: OpenStaticContentOptions): void;
}
